import { render, staticRenderFns } from "./SwitchComponents.vue?vue&type=template&id=3f75e6a2&scoped=true&"
import script from "./SwitchComponents.vue?vue&type=script&lang=js&"
export * from "./SwitchComponents.vue?vue&type=script&lang=js&"
import style0 from "./SwitchComponents.vue?vue&type=style&index=0&id=3f75e6a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f75e6a2",
  null
  
)

export default component.exports